import React from 'react';
import PropTypes from 'prop-types';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import { withStyles } from '@material-ui/core/styles';
import { NavLink } from '../NavLink';

const StyledNav = withStyles({
    root: {
        display: 'block',
        width: '100%',
        padding: '0',
        margin: '0'
    }
})(List);

const StyledListItem = withStyles({
    root: {
        display: 'block',
        width: '100%',
        padding: '0',
        margin: '0'
    }
})(ListItem);

const NavList = ({ elemento, listaFilhos }) => {
    const getElementoFilho = localListaElemento => {
        return localListaElemento.map(element => (
            <StyledListItem key={element.texto}>
                <NavLink
                    to={element.link}
                    key={`link ${element.texto}`}
                    texto={element.texto}
                />
            </StyledListItem>
        ));
    };

    return (
        <StyledNav component='nav' key={`List ${elemento.texto}`}>
            {getElementoFilho(listaFilhos)}
        </StyledNav>
    );
};

NavList.propTypes = {
    elemento: PropTypes.shape({
        texto: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
        permissao: PropTypes.string
    }).isRequired,
    listaFilhos: PropTypes.arrayOf(
        PropTypes.shape({
            texto: PropTypes.string.isRequired,
            link: PropTypes.string.isRequired,
            permissao: PropTypes.string.isRequired
        })
    ).isRequired
};

export { NavList };
